module.exports = __webpack_public_path__ + "static/img/car.6ae15048.png";